'use client';

import { useTranslations } from 'next-intl';
import { BeardmanError } from '~/components/Beardman/BeardmanError/BeardmanError';

export default function Error() {
  const t = useTranslations('error.global');
  return (
    <div className="error">
      <h2 className="text-center">
        {t('description')}
      </h2>
      <BeardmanError />
    </div>
  );
}
